import {
	SOURCESAFE_ENTRIES_FETCH_REQUEST,
	SOURCESAFE_ENTRIES_FETCH_FAILURE,
	SOURCESAFE_ENTRIES_FETCH_SUCCESS,
	SOURCESAFE_ENTRY_CREATE_REQUEST,
	SOURCESAFE_ENTRY_CREATE_FAILURE,
	SOURCESAFE_ENTRY_CREATE_SUCCESS,
	SOURCESAFE_ENTRY_DELETE_REQUEST,
	SOURCESAFE_ENTRY_DELETE_FAILURE,
	SOURCESAFE_ENTRY_DELETE_SUCCESS,
	SOURCESAFE_ENTRY_RESET_MESSAGE,
	SOURCESAFE_ENTRY_SET_FILE,
	SOURCESAFE_ENTRY_SET,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	file: null,
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case SOURCESAFE_ENTRY_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case SOURCESAFE_ENTRY_SET_FILE:
			return {
				...state,
				file: payload.file,
			};

		case SOURCESAFE_ENTRY_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case SOURCESAFE_ENTRIES_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case SOURCESAFE_ENTRIES_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case SOURCESAFE_ENTRIES_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case SOURCESAFE_ENTRY_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case SOURCESAFE_ENTRY_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case SOURCESAFE_ENTRY_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				file: null,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case SOURCESAFE_ENTRY_DELETE_REQUEST:
			return {
				...state,
				isDeleting: true,
				message: {
					type: '',
					text: '',
				},
			};

		case SOURCESAFE_ENTRY_DELETE_FAILURE:
			return {
				...state,
				isDeleting: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case SOURCESAFE_ENTRY_DELETE_SUCCESS:
			return {
				...state,
				isDeleting: false,
				file: null,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/sourcesafeEntries.js